import GenericVideoPlayer from "./GenericVideoPlayer.js";

export default function DemoPlyer() {
    return (
        <div style={{ padding: 24 }}>
            {/* YouTube */}
            <GenericVideoPlayer
                url="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
                poster="https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg"
            />
            <br />

            {/* Vimeo */}
            <GenericVideoPlayer
                url="https://vimeo.com/76979871"
                className="mt-8"
            />
            <br />

            {/* MP4 / HLS etc. */}
            <GenericVideoPlayer
                url="https://www.w3schools.com/html/mov_bbb.mp4"
                className="mt-8"
            />
        </div>
    );
}
